import React from 'react';
import axios from 'axios';
import {
    Header,
    Segment,
    Form,
    Table,
    Button,
    TextArea,
    Message,
    Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { Link, Redirect } from 'react-router-dom';
import {
    fetchAllAcademicYears,
    fetchFaculties,
    fetchStudyCycle,
    fetchTitles,
    fetchLanguages
} from '../../Lookups/util';
import CopyStudyProgramCourses from './CopyStudyProgramCourses';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

class CopyStudyProgram extends React.Component {
    constructor(props) {
        super(props);

        const implementation = JSON.parse(localStorage.getItem('implementation')) || {};
        const studyProgram = implementation.studyProgram || {};
        const englishTranslation = implementation.englishTranslation || {};
        const studyCycles = implementation.studyCycles || [];
        const departments = implementation.departments || [];
        const studyProgramTitle = implementation.studyProgramTitle || null;
        const languages = implementation.languages || [];

        this.state = {
            loading: true,
            saving: false,
            success: null,
            createdStudyProgram: null,

            organizationalUnits: [],
            studyCyclesOptions: [],
            academicYears: [],
            titles: [],
            allLanguages: [],

            implementation,

            studyProgramBasic: studyProgram.studyProgramBasic || null,
            academicYearStart: studyProgram.academicYearStart || null,
            name: '',
            ects: studyProgram.ects || '',
            durationYear: studyProgram.durationYear || '',
            durationSemester: studyProgram.durationSemester || '',
            description: studyProgram.description || '',
            enrollmentTerms: studyProgram.enrollmentTerms || '',
            studyRules: studyProgram.studyRules || '',
            nextCycleEnrollmentPossibility: studyProgram.nextCycleEnrollmentPossibility || '',
            professionalStatus: studyProgram.professionalStatus || '',
            additionalInformation: studyProgram.additionalInformation || '',
            additionalInformationSource: studyProgram.additionalInformationSource || '',
            studyGoals: studyProgram.studyGoals || '',
            studyOutcomes: studyProgram.studyOutcomes || '',
            details: studyProgram.details || '',
            gradingScale: studyProgram.gradingScale || '',
            classificationOfQualification: studyProgram.classificationOfQualification || '',
            title: studyProgramTitle && studyProgramTitle.id ? studyProgramTitle.id : null,
            studyCycleId: studyCycles.length > 0 ? studyCycles[0].id : null,
            organizationalUnitIds: departments.length > 0 ? departments.map(el => el.id) : [],
            languageIds: languages.length > 0 ? languages.map(el => el.id) : [],

            nameEng: '',
            descriptionEng: englishTranslation.description || '',
            enrollmentTermsEng: englishTranslation.enrollmentTerms || '',
            studyRulesEng: englishTranslation.studyRules || '',
            nextCycleEnrollmentPossibilityEng: englishTranslation.nextCycleEnrollmentPossibility || '',
            professionalStatusEng: englishTranslation.professionalStatus || '',
            additionalInformationEng: englishTranslation.additionalInformation || '',
            additionalInformationSourceEng: englishTranslation.additionalInformationSource || '',
            studyGoalsEng: englishTranslation.studyGoals || '',
            studyOutcomesEng: englishTranslation.studyOutcomes || '',
            detailsEng: englishTranslation.details || '',
            gradingScaleEng: englishTranslation.gradingScale || '',
            classificationOfQualificationEng: englishTranslation.classificationOfQualification || '',

            showCoursesCopy: false,
            redirectToImplementations: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.copyStudyProgramImplementation = this.copyStudyProgramImplementation.bind(this);
        this.handleCoursesCopyFinished = this.handleCoursesCopyFinished.bind(this);
    }

    componentDidMount() {
        axios.all([
            fetchFaculties(),
            fetchStudyCycle(),
            fetchAllAcademicYears(),
            fetchTitles(),
            fetchLanguages()
        ])
            .then(axios.spread((orgUnitsRes, studyCycleRes, academicYearsRes, titlesRes, languagesRes) => {
                const organizationalUnits = orgUnitsRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.name,
                    item: el
                }));

                const studyCyclesOptions = studyCycleRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.displayName,
                    item: el
                }));

                const academicYears = academicYearsRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.name,
                    item: el
                })).reverse();

                const titles = titlesRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.name,
                    item: el
                }));

                const allLanguages = languagesRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.name,
                    item: el
                }));

                this.setState({
                    organizationalUnits,
                    studyCyclesOptions,
                    academicYears,
                    titles,
                    allLanguages,
                    loading: false
                });
            }))
            .catch(() => {
                this.setState({ loading: false });
                toast('Greška pri učitavanju šifarnika.');
            });
    }

    handleCoursesCopyFinished() {
        this.setState({
            showCoursesCopy: false,
            redirectToImplementations: true
        });
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });
    }

    handleDropdownChange(e, { name, value }) {
        if (name === 'academicYearStart') {
            const selected = this.state.academicYears.find(el => el.value === value);
            this.setState({ academicYearStart: selected ? selected.item : null });
            return;
        }

        if (name === 'studyCycleId') {
            this.setState({ studyCycleId: value });
            return;
        }

        if (name === 'title') {
            this.setState({ title: value });
            return;
        }

        if (name === 'languageIds') {
            this.setState({ languageIds: value || [] });
        }
    }

    copyStudyProgramImplementation() {
        const {
            implementation,
            studyProgramBasic,
            academicYearStart,
            name,
            ects,
            durationYear,
            durationSemester,
            description,
            enrollmentTerms,
            studyRules,
            nextCycleEnrollmentPossibility,
            professionalStatus,
            additionalInformation,
            additionalInformationSource,
            studyGoals,
            studyOutcomes,
            details,
            gradingScale,
            classificationOfQualification,
            languageIds,
            studyCycleId,
            organizationalUnitIds,
            title,
            nameEng,
            descriptionEng,
            enrollmentTermsEng,
            studyRulesEng,
            nextCycleEnrollmentPossibilityEng,
            professionalStatusEng,
            additionalInformationEng,
            additionalInformationSourceEng,
            studyGoalsEng,
            studyOutcomesEng,
            detailsEng,
            gradingScaleEng,
            classificationOfQualificationEng
        } = this.state;

        if (!name || !name.trim()) {
            toast('Morate unijeti naziv implementacije.');
            return;
        }

        if (!nameEng || !nameEng.trim()) {
            toast('Morate unijeti naziv implementacije na engleskom jeziku.');
            return;
        }

        if (!languageIds || !languageIds.length) {
            toast('Morate odabrati najmanje jedan jezik.');
            return;
        }

        const studyProgramData = implementation.studyProgram || {};

        let studyProgram = {};

        if (studyProgramBasic && studyProgramBasic.id) {
            studyProgram = { ...studyProgram, studyProgramBasic: studyProgramBasic.id };
        } else if (studyProgramData.studyProgramBasic && studyProgramData.studyProgramBasic.id) {
            studyProgram = { ...studyProgram, studyProgramBasic: studyProgramData.studyProgramBasic.id };
        }

        if (academicYearStart && academicYearStart.id) {
            studyProgram = { ...studyProgram, academicYearStart: academicYearStart.id };
        }

        if (studyProgramData.studyProgramType && studyProgramData.studyProgramType.id) {
            studyProgram = { ...studyProgram, studyProgramTypeId: studyProgramData.studyProgramType.id };
        }

        if (name) studyProgram = { ...studyProgram, name };
        if (ects !== '' && ects !== null) studyProgram = { ...studyProgram, ects };
        if (durationYear !== '' && durationYear !== null) studyProgram = { ...studyProgram, durationYear };
        if (durationSemester !== '' && durationSemester !== null) studyProgram = { ...studyProgram, durationSemester };
        if (title) studyProgram = { ...studyProgram, titleId: title };

        if (description !== undefined) studyProgram = { ...studyProgram, description: description || '' };
        if (enrollmentTerms !== undefined) studyProgram = { ...studyProgram, enrollmentTerms: enrollmentTerms || '' };
        if (studyRules !== undefined) studyProgram = { ...studyProgram, studyRules: studyRules || '' };
        if (nextCycleEnrollmentPossibility !== undefined) {
            studyProgram = { ...studyProgram, nextCycleEnrollmentPossibility: nextCycleEnrollmentPossibility || '' };
        }
        if (professionalStatus !== undefined) {
            studyProgram = { ...studyProgram, professionalStatus: professionalStatus || '' };
        }
        if (additionalInformation !== undefined) {
            studyProgram = { ...studyProgram, additionalInformation: additionalInformation || '' };
        }
        if (additionalInformationSource !== undefined) {
            studyProgram = { ...studyProgram, additionalInformationSource: additionalInformationSource || '' };
        }
        if (studyGoals !== undefined) studyProgram = { ...studyProgram, studyGoals: studyGoals || '' };
        if (studyOutcomes !== undefined) studyProgram = { ...studyProgram, studyOutcomes: studyOutcomes || '' };
        if (details !== undefined) studyProgram = { ...studyProgram, details: details || '' };
        if (gradingScale !== undefined) studyProgram = { ...studyProgram, gradingScale: gradingScale || '' };
        if (classificationOfQualification !== undefined) {
            studyProgram = { ...studyProgram, classificationOfQualification: classificationOfQualification || '' };
        }

        if (studyCycleId) studyProgram = { ...studyProgram, studyCycleId };
        if (organizationalUnitIds && organizationalUnitIds.length) {
            studyProgram = { ...studyProgram, organizationalUnitIds };
        }
        if (languageIds && languageIds.length) {
            studyProgram = { ...studyProgram, languageIds };
        }

        let translations = [];

        if (nameEng) {
            translations = [
                {
                    name: nameEng,
                    language: { twoLetterCode: 'en' },
                    description: descriptionEng || '',
                    enrollmentTerms: enrollmentTermsEng || '',
                    studyRules: studyRulesEng || '',
                    nextCycleEnrollmentPossibility: nextCycleEnrollmentPossibilityEng || '',
                    professionalStatus: professionalStatusEng || '',
                    additionalInformation: additionalInformationEng || '',
                    additionalInformationSource: additionalInformationSourceEng || '',
                    studyGoals: studyGoalsEng || '',
                    studyOutcomes: studyOutcomesEng || '',
                    details: detailsEng || '',
                    gradingScale: gradingScaleEng || '',
                    classificationOfQualification: classificationOfQualificationEng || '',
                    studyProgram: null
                }
            ];
        }

        if (translations.length) {
            studyProgram = { ...studyProgram, translations };
        }

        console.log('study payload', studyProgram);

        this.setState({ saving: true });

        axios.post('/study-programs/save', studyProgram)
            .then(res => {
                const newSP = res.data;

                localStorage.setItem('newSP', JSON.stringify(newSP));
                localStorage.setItem('sourceImplementation', JSON.stringify(this.state.implementation));

                this.setState({
                    saving: false,
                    success: true,
                    createdStudyProgram: newSP,
                    showCoursesCopy: true
                });
            })
            .catch(err => {
                console.log('err.response', err.response);
                console.log('err.response.data', err.response && err.response.data);

                this.setState({
                    saving: false,
                    success: false
                });

                toast(err.response && err.response.data
                    ? (typeof err.response.data === 'string' ? err.response.data : 'Greška pri kopiranju studijskog programa.')
                    : 'Greška pri kopiranju studijskog programa.');
            });
    }

    renderRow(label, currentValue, field) {
        return (
            <Table.Row>
                <Table.Cell verticalAlign="middle" width={4}><b>{label}</b></Table.Cell>
                <Table.Cell verticalAlign="middle" width={6}>{currentValue || ''}</Table.Cell>
                <Table.Cell verticalAlign="middle" width={6}>{field}</Table.Cell>
            </Table.Row>
        );
    }

    render() {
        const {
            loading,
            saving,
            success,
            createdStudyProgram,
            implementation,
            academicYears,
            studyCyclesOptions,
            titles,
            allLanguages
        } = this.state;

        const studyProgram = implementation.studyProgram || {};
        const englishTranslation = implementation.englishTranslation || {};
        const basicName = studyProgram.studyProgramBasic ? studyProgram.studyProgramBasic.name : '';

        if (loading) {
            return (
                <Segment basic>
                    <Loader active inline="centered" />
                </Segment>
            );
        }

        if (this.state.redirectToImplementations) {
            return (
                <Redirect
                    to={{
                        pathname: '/osnovni-studijski-programi/implementacije',
                        state: {
                            copiedCourses: true
                        }
                    }}
                />
            );
        }

        if (this.state.showCoursesCopy && this.state.createdStudyProgram) {
            return (
                <CopyStudyProgramCourses
                    newSP={this.state.createdStudyProgram}
                    implementation={this.state.implementation}
                    onFinish={this.handleCoursesCopyFinished}
                    history={this.props.history}
                    showImplementationCopiedToast
                />
            );
        }

        return (
            <div>
                <Header as="h1">Kopiranje implementacije studijskog programa</Header>

                <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3">
                            <Header.Content>
                                Implementacija studijskog programa: {studyProgram.name}
                            </Header.Content>
                            <Header.Subheader>
                                {basicName}
                            </Header.Subheader>
                        </Header>

                        {success === true && (
                            <Message positive>
                                Studijski program je uspješno kopiran.
                                {createdStudyProgram && createdStudyProgram.name ? ` Kreiran je program: ${createdStudyProgram.name}.` : ''}
                            </Message>
                        )}

                        {success === false && (
                            <Message negative>
                                Došlo je do greške pri kopiranju studijskog programa.
                            </Message>
                        )}
                    </Segment>

                    <Segment clearing>
                        <Form>
                            <Header as="h4">Bosanski / hrvatski / srpski jezik</Header>

                            <Table celled unstackable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell verticalAlign="middle">Naziv polja</Table.HeaderCell>
                                        <Table.HeaderCell verticalAlign="middle">Trenutna vrijednost</Table.HeaderCell>
                                        <Table.HeaderCell verticalAlign="middle">Nova vrijednost</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.renderRow(
                                        'Akademska godina',
                                        studyProgram.academicYearStart ? studyProgram.academicYearStart.name : '',
                                        <Form.Dropdown
                                            fluid
                                            search
                                            selection
                                            options={academicYears}
                                            name="academicYearStart"
                                            value={this.state.academicYearStart ? this.state.academicYearStart.id : null}
                                            onChange={this.handleDropdownChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Naziv implementacije',
                                        studyProgram.name,
                                        <Form.Input
                                            name="name"
                                            value={this.state.name}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'ECTS',
                                        studyProgram.ects,
                                        <Form.Input
                                            name="ects"
                                            value={this.state.ects}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Trajanje u godinama',
                                        studyProgram.durationYear,
                                        <Form.Input
                                            name="durationYear"
                                            value={this.state.durationYear}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Trajanje u semestrima',
                                        studyProgram.durationSemester,
                                        <Form.Input
                                            name="durationSemester"
                                            value={this.state.durationSemester}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Ciklus studija',
                                        implementation.studyCycles && implementation.studyCycles.length ? implementation.studyCycles[0].displayName : '',
                                        <Form.Dropdown
                                            fluid
                                            search
                                            selection
                                            options={studyCyclesOptions}
                                            name="studyCycleId"
                                            value={this.state.studyCycleId}
                                            onChange={this.handleDropdownChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Jezici',
                                        implementation.languages && implementation.languages.length
                                            ? implementation.languages.map(el => el.name).join(', ')
                                            : '',
                                        <Form.Dropdown
                                            fluid
                                            multiple
                                            search
                                            selection
                                            options={allLanguages}
                                            name="languageIds"
                                            value={this.state.languageIds}
                                            onChange={this.handleDropdownChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Titula',
                                        implementation.studyProgramTitle ? implementation.studyProgramTitle.name : '',
                                        <Form.Dropdown
                                            fluid
                                            search
                                            selection
                                            options={titles}
                                            name="title"
                                            value={this.state.title}
                                            onChange={this.handleDropdownChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Organizaciona jedinica',
                                        implementation.departments && implementation.departments.length
                                            ? implementation.departments.map(el => el.name).join(', ')
                                            : '',
                                        <Form.Input
                                            value={
                                                implementation.departments && implementation.departments.length
                                                    ? implementation.departments.map(el => el.name).join(', ')
                                                    : ''
                                            }
                                            readOnly
                                        />
                                    )}

                                    {this.renderRow(
                                        'Opis',
                                        studyProgram.description,
                                        <Form.Field
                                            control={TextArea}
                                            name="description"
                                            value={this.state.description}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Uslovi upisa',
                                        studyProgram.enrollmentTerms,
                                        <Form.Field
                                            control={TextArea}
                                            name="enrollmentTerms"
                                            value={this.state.enrollmentTerms}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Pravila studiranja',
                                        studyProgram.studyRules,
                                        <Form.Field
                                            control={TextArea}
                                            name="studyRules"
                                            value={this.state.studyRules}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Mogućnost upisa narednog ciklusa',
                                        studyProgram.nextCycleEnrollmentPossibility,
                                        <Form.Field
                                            control={TextArea}
                                            name="nextCycleEnrollmentPossibility"
                                            value={this.state.nextCycleEnrollmentPossibility}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Profesionalni status',
                                        studyProgram.professionalStatus,
                                        <Form.Field
                                            control={TextArea}
                                            name="professionalStatus"
                                            value={this.state.professionalStatus}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Dodatne informacije',
                                        studyProgram.additionalInformation,
                                        <Form.Field
                                            control={TextArea}
                                            name="additionalInformation"
                                            value={this.state.additionalInformation}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Izvor dodatnih informacija',
                                        studyProgram.additionalInformationSource,
                                        <Form.Field
                                            control={TextArea}
                                            name="additionalInformationSource"
                                            value={this.state.additionalInformationSource}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Ciljevi studija',
                                        studyProgram.studyGoals,
                                        <Form.Field
                                            control={TextArea}
                                            name="studyGoals"
                                            value={this.state.studyGoals}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Ishodi učenja',
                                        studyProgram.studyOutcomes,
                                        <Form.Field
                                            control={TextArea}
                                            name="studyOutcomes"
                                            value={this.state.studyOutcomes}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Detalji',
                                        studyProgram.details,
                                        <Form.Field
                                            control={TextArea}
                                            name="details"
                                            value={this.state.details}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Skala ocjenjivanja',
                                        studyProgram.gradingScale,
                                        <Form.Field
                                            control={TextArea}
                                            name="gradingScale"
                                            value={this.state.gradingScale}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Klasifikacija kvalifikacije',
                                        studyProgram.classificationOfQualification,
                                        <Form.Field
                                            control={TextArea}
                                            name="classificationOfQualification"
                                            value={this.state.classificationOfQualification}
                                            onChange={this.handleInputChange}
                                        />
                                    )}
                                </Table.Body>
                            </Table>

                            <Header as="h4" style={{ marginTop: '25px' }}>Engleski jezik</Header>

                            <Table celled unstackable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Naziv polja</Table.HeaderCell>
                                        <Table.HeaderCell>Trenutna vrijednost</Table.HeaderCell>
                                        <Table.HeaderCell>Nova vrijednost</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.renderRow(
                                        'Naziv',
                                        englishTranslation.name,
                                        <Form.Input
                                            name="nameEng"
                                            value={this.state.nameEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Opis',
                                        englishTranslation.description,
                                        <Form.Field
                                            control={TextArea}
                                            name="descriptionEng"
                                            value={this.state.descriptionEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Uslovi upisa',
                                        englishTranslation.enrollmentTerms,
                                        <Form.Field
                                            control={TextArea}
                                            name="enrollmentTermsEng"
                                            value={this.state.enrollmentTermsEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Pravila studiranja',
                                        englishTranslation.studyRules,
                                        <Form.Field
                                            control={TextArea}
                                            name="studyRulesEng"
                                            value={this.state.studyRulesEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Mogućnost upisa narednog ciklusa',
                                        englishTranslation.nextCycleEnrollmentPossibility,
                                        <Form.Field
                                            control={TextArea}
                                            name="nextCycleEnrollmentPossibilityEng"
                                            value={this.state.nextCycleEnrollmentPossibilityEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Profesionalni status',
                                        englishTranslation.professionalStatus,
                                        <Form.Field
                                            control={TextArea}
                                            name="professionalStatusEng"
                                            value={this.state.professionalStatusEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Dodatne informacije',
                                        englishTranslation.additionalInformation,
                                        <Form.Field
                                            control={TextArea}
                                            name="additionalInformationEng"
                                            value={this.state.additionalInformationEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Izvor dodatnih informacija',
                                        englishTranslation.additionalInformationSource,
                                        <Form.Field
                                            control={TextArea}
                                            name="additionalInformationSourceEng"
                                            value={this.state.additionalInformationSourceEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Ciljevi studija',
                                        englishTranslation.studyGoals,
                                        <Form.Field
                                            control={TextArea}
                                            name="studyGoalsEng"
                                            value={this.state.studyGoalsEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Ishodi učenja',
                                        englishTranslation.studyOutcomes,
                                        <Form.Field
                                            control={TextArea}
                                            name="studyOutcomesEng"
                                            value={this.state.studyOutcomesEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Detalji',
                                        englishTranslation.details,
                                        <Form.Field
                                            control={TextArea}
                                            name="detailsEng"
                                            value={this.state.detailsEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Skala ocjenjivanja',
                                        englishTranslation.gradingScale,
                                        <Form.Field
                                            control={TextArea}
                                            name="gradingScaleEng"
                                            value={this.state.gradingScaleEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}

                                    {this.renderRow(
                                        'Klasifikacija kvalifikacije',
                                        englishTranslation.classificationOfQualification,
                                        <Form.Field
                                            control={TextArea}
                                            name="classificationOfQualificationEng"
                                            value={this.state.classificationOfQualificationEng}
                                            onChange={this.handleInputChange}
                                        />
                                    )}
                                </Table.Body>
                            </Table>

                            <Button
                                floated="right"
                                color="blue"
                                onClick={this.copyStudyProgramImplementation}
                                loading={saving}
                                disabled={saving}
                            >
                                Sačuvaj kopiju
                            </Button>

                            <Button
                                as={Link}
                                to="/osnovni-studijski-programi/implementacije"
                                floated="right"
                                basic="true"
                                color="blue"
                            >
                                Odustani
                            </Button>
                        </Form>
                    </Segment>
                </Segment.Group>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default CopyStudyProgram;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/CopyStudyProgram.js